import { BbFile, UploadService } from './../../../services/upload.service';
import { PublicationService } from '../../../services/publication.service';
import { WebSocketsService } from '../../../services/web-sockets.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FilterPipe } from './../../../pipes/filter.pipe';
import { Publication } from '../../../interfaces/publication';

@Component({
	selector: 'bb-upload-status-box',
	templateUrl: './bb-upload-status-box.component.html',
	styleUrls: ['./bb-upload-status-box.component.scss']
})

export class BbUploadStatusBoxComponent implements OnInit, OnDestroy {
	filterPipe: FilterPipe = new FilterPipe();
	expanded = false;
	useDevSocket: boolean;

	totalPercentage: number;
	status: string;
	totalUploadSpeed: number;
	websocketSubscription: Subscription;
	private subscriptions: Subscription = new Subscription();

	constructor(private translate: TranslateService,
		public uploadService: UploadService,
		private webSocketsService: WebSocketsService,
		private publicationService: PublicationService) {
		this.useDevSocket = false;
	}

	ngOnInit() {

		this.subscriptions.add(this.webSocketsService.subscribeToChannel('processing').subscribe((websocketEvent: any) => {
			if (websocketEvent?.ev && this.expanded) {
				this.uploadService.setProcessingStatus(websocketEvent);
			}
		}));

		this.subscriptions.add(this.webSocketsService.subscribeToChannel('import').subscribe((websocketEvent: any) => {
			if (websocketEvent && websocketEvent.ev) {
				this.uploadService.setImportStatus(websocketEvent);
			}
		}));

		this.subscriptions.add(this.webSocketsService.subscribeToChannel('export').subscribe((websocketEvent: any) => {
			if (websocketEvent && websocketEvent.Object && websocketEvent.ev) {
				this.uploadService.setExportStatus(websocketEvent);
			}
		}));

		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			if (publication) {
				const baseUrl = publication.baseurl;
				if (baseUrl.search(/\.dev\./) > -1 || baseUrl.search(/^dev\./) > -1) {
					this.useDevSocket = true;
					this.updateSocket(this.useDevSocket);
				}
			}
		}));

		this.subscriptions.add(this.uploadService.addedObservable.subscribe((bbFile: BbFile) => {
			this.expanded = true;
		}));

		this.subscriptions.add(this.uploadService.progressObservable.subscribe((bbFile: BbFile) => {
			this.totalPercentage = this.uploadService.getAveragePercentage();
			this.status = this.getStatus();
			this.totalUploadSpeed = this.uploadService.getUploadSpeed();
		}));

		this.subscriptions.add(this.uploadService.completedObservable.subscribe((bbFile: BbFile) => {
			this.totalPercentage = this.uploadService.getAveragePercentage();
			this.status = this.getStatus();
		}));

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	updateSocket(val: boolean) {
		this.webSocketsService.useDevelopment = val;
	}

	getStatus() {
		const completed = this.uploadService.getCountByStatus('completed');
		const cancelled = this.uploadService.getCountByStatus('cancelled');
		const error = this.uploadService.getCountByStatus('error');
		const started = this.uploadService.getCountByStatus('started');

		if (this.uploadService.getVisibleCount() === 0) {
			return this.translate.instant('NO_CURRENT_UPLOADS');
		} else {
			const str = [];
			if (started > 0) {
				str.push(this.translate.instant(started === 1 ? 'CURRENTLY_UPLOADING_ONE_FILE' : 'CURRENTLY_UPLOADING_X_FILES', { x: started }));
			}
			if (completed > 0) {
				str.push(this.translate.instant(completed === 1 ? 'ONE_COMPLETED_UPLOAD' : 'X_COMPLETED_UPLOADS', { x: completed }));
			}
			if (cancelled > 0) {
				str.push(this.translate.instant(cancelled === 1 ? 'ONE_CANCELLED_UPLOAD' : 'X_CANCELLED_UPLOADS', { x: cancelled }));
			}
			if (error > 0) {
				str.push(this.translate.instant(error === 1 ? 'ONE_UPLOAD_ERROR' : 'X_UPLOAD_ERRORS', { x: error }));
			}
			return str.join(', ');
		}
	}

	cancel(file: BbFile) {
		this.uploadService.cancelUpload(file);
	}

	hideUploadBox() {
		this.uploadService.hideAll();
	}
}
